<template>
  <el-form
    ref="takeoffPassengersDataForm"
    :model="model"
    :rules="rules"
    label-width="10em"
    label-position="left"
    class="takeoff-passengers-data-form"
  >
    <BillingYm v-model="billingYm" :required="!searchMode" :searchCond="true" :mode="billingYmMode" :disabled="editMode" :actualprop=true :actualmode=2 />
    <BillToCode v-model="billToCode" :required="!searchMode" :searchCond="searchMode"
      :disabled="editMode || decisionDisabled()" :autocomplete-list="autocompleteCustomerCodeSet" />
    <AirportCode v-model="destinationAirportCode" label="目的地" prop="destination_airport_code"
      :required="!searchMode" :searchCond="searchMode" :disabled="editMode"
      :autocomplete-list="autocompleteAirportCodeSet" />
    <RouteCode v-model="routeCode" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" />
    <!-- <PaidPassengers v-model="paidPassengers" :required="!searchMode" :searchCond="searchMode"/> -->
    <Numeric v-model="paidPassengers" label="有償旅客数" placeholder="0～999999" prop="paid_passengers" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode" :min="0" :max="999999" :step="1"/>
    <!-- <PaidCargoVolume v-model="paidCargoVolume" :required="!searchMode" :searchCond="searchMode"/> -->
    <Numeric v-model="paidCargoVolume" label="有償貨物量[kg]" placeholder="0～99999999" prop="paid_cargo_volume" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode" :min="0" :max="99999999" :step="1"/>
    <!-- <PaidFlights v-model="paidFlights" :searchCond="searchMode"/> -->
    <Numeric v-model="paidFlights" label="有償飛行件数" placeholder="0～999" prop="paid_flights" :searchCond="searchMode" :disabled="editDisabledMode" :min="0" :max="999" :step="1"/>
  </el-form>
</template>

<script>
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import BillToCode from '@/components/molecules/form/autocomplete/BillToCode.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
import RouteCode from '@/components/molecules/form/select/RouteCode.vue'
// import PaidFlights from '@/components/molecules/form/number/PaidFlights.vue'
// import PaidPassengers from '@/components/molecules/form/number/PaidPassengers.vue'
// import PaidCargoVolume from '@/components/molecules/form/number/PaidCargoVolume.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'

export default {
  components: {
    BillingYm,
    BillToCode,
    AirportCode,
    RouteCode,
    // PaidFlights,
    // PaidPassengers,
    // PaidCargoVolume
    Numeric
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    // billingYmMode: String,
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    billingYmMode: {
      type: String,
      default: 'search'
    },
    editDisabledMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    billingYm: {
      get () {
        return this.model.billing_ym
      },
      set (billingYm) {
        const form = { ...this.model }
        form.billing_ym = billingYm
        this.$emit('input', form)
      }
    },
    billToCode: {
      get () {
        return this.model.bill_to_code
      },
      set (billToCode) {
        const form = { ...this.model }
        form.bill_to_code = billToCode
        this.$emit('input', form)
      }
    },
    destinationAirportCode: {
      get () {
        return this.model.destination_airport_code
      },
      set (destinationAirportCode) {
        const form = { ...this.model }
        form.destination_airport_code = destinationAirportCode
        this.$emit('input', form)
      }
    },
    routeCode: {
      get () {
        return this.model.route_code
      },
      set (routeCode) {
        const form = { ...this.model }
        form.route_code = routeCode
        this.$emit('input', form)
      }
    },
    paidFlights: {
      get () {
        return this.model.paid_flights
      },
      set (paidFlights) {
        const form = { ...this.model }
        form.paid_flights = paidFlights
        this.$emit('input', form)
      }
    },
    paidPassengers: {
      get () {
        return this.model.paid_passengers
      },
      set (paidPassengers) {
        const form = { ...this.model }
        form.paid_passengers = paidPassengers
        this.$emit('input', form)
      }
    },
    paidCargoVolume: {
      get () {
        return this.model.paid_cargo_volume
      },
      set (paidCargoVolume) {
        const form = { ...this.model }
        form.paid_cargo_volume = paidCargoVolume
        this.$emit('input', form)
      }
    },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
  },
  mounted () {
  },
  methods: {
    decisionDisabled () {
      var result = false
      if (this.$loginuser.get('role_id').indexOf('airline') !== -1) {
        result = true
        this.model.bill_to_code = this.$loginuser.get('customer_code')
      }
      return result
    },
    clearFields () {
      this.$refs.takeoffPassengersDataForm.resetFields()
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.takeoffPassengersDataForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.takeoff-passengers-data-form {
  .el-form-item{
    .el-input__inner{
      width: 15em;
    }
  }
}
</style>
